export default {
  methods: {
    xhJumpPDSearchType (kw) {
      let path = this.$route.path
      const index = path.indexOf('/searchType/')
      if (index !== -1) {
        path = path.slice(0, index)
      }
      path = `${path}/searchType/All/1/${kw}/`
      this.$router.push({path})
    }
  }
}
